// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveButton-saveBtn-UsGLc {
	line-height: 43px;
}

.SaveButton-loaderSaveText-sNtRx,
.SaveButton-loaderSaveText-sNtRx div {
	display: inline;
}

.SaveButton-loaderSaveText-sNtRx .savaLoader {
	display: inline;
	margin: 0;
	font-size: 18px !important;
	font-weight: 600;
	line-height: inherit;
	color: var(--secondary-oscuro);
	white-space: nowrap;
}

.SaveButton-loaderSaveText-sNtRx .savaLoader span {
	color: inherit;
}

.SaveButton-loaderSaveText-sNtRx .savingDotsLoader {
	position: static !important;
	top: auto !important;
	right: auto !important;
	font-size: inherit !important;
	line-height: inherit;
}

span {
	text-decoration: none;
}

span:hover, span:active, span:focus, span:visited {
	text-decoration: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/List/SaveButton.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,SAAS;CACT,0BAA0B;CAC1B,gBAAgB;CAChB,oBAAoB;CACpB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,2BAA2B;CAC3B,oBAAoB;CACpB,sBAAsB;CACtB,6BAA6B;CAC7B,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AACA;CACC,gCAAgC;AACjC","sourcesContent":[".saveBtn {\n\tline-height: 43px;\n}\n\n.loaderSaveText,\n.loaderSaveText div {\n\tdisplay: inline;\n}\n\n.loaderSaveText :global(.savaLoader) {\n\tdisplay: inline;\n\tmargin: 0;\n\tfont-size: 18px !important;\n\tfont-weight: 600;\n\tline-height: inherit;\n\tcolor: var(--secondary-oscuro);\n\twhite-space: nowrap;\n}\n\n.loaderSaveText :global(.savaLoader) span {\n\tcolor: inherit;\n}\n\n.loaderSaveText :global(.savingDotsLoader) {\n\tposition: static !important;\n\ttop: auto !important;\n\tright: auto !important;\n\tfont-size: inherit !important;\n\tline-height: inherit;\n}\n\nspan {\n\ttext-decoration: none;\n}\nspan:hover, span:active, span:focus, span:visited {\n\ttext-decoration: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saveBtn": `SaveButton-saveBtn-UsGLc`,
	"loaderSaveText": `SaveButton-loaderSaveText-sNtRx`
};
module.exports = ___CSS_LOADER_EXPORT___;
